// Roles allowed to create a workspace. Must match the API guard on POST /workspaces/
// (src/bp/workspaces/views.py), which answers 403 to anyone else.
export const WORKSPACE_CREATOR_ROLES = ['admin', 'brand specialist'];

export const canCreateWorkspace = (role?: string | null): boolean =>
  WORKSPACE_CREATOR_ROLES.includes((role ?? '').toLowerCase());
